
import { ItemInfo } from '../../../features/typescript/itemInfo';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import LabelWithValue from '../../../features/core/components/Indicators/LabelWithValue.vue';
import { LabelForKey } from '../../../features/core/utils/LabelForKey';
import {UnitForKey} from '../../core/utils/UnitForKey'
import { EventBus, TypeEventBus } from '../../../features/core/utils';
@Component({
    components: {
        LabelWithValue
    }
})
export default class ItemIndicators extends Vue {
    @Prop({default: () => ({})}) itemInfo!: ItemInfo;
    
    availableKeys: object = LabelForKey;
    calculatingPolygonArea: boolean = false;



    valueFormatter(value: number | string, key:string = ''){
      if(!value) return '-';

      let valueUnit = UnitForKey[key];

      if(valueUnit){
        return `${value} ${valueUnit}`
      }

      return `${value}`
    }

    mounted(){
      
    }
    
    
}
